export default new class Calendar {
  constructor() {
    this.classBtnMonthToggle = '.month-toggle';
    this.classBtnDateToggle = '.date-toggle';
    this.calendarWrapper = '.calendar';
    this.ratesWrapper = '.rates';
    this.preLoaderSelector = '.rates__preloader';
    this.handleClick();
  }

  handleClick() {
    document.addEventListener('click', (e) => {
      if (e.target.matches(`${this.classBtnMonthToggle}`)) {
        this.month = e.target.dataset.month;
        this.monthToggle();
      }

      if (e.target.matches(`${this.classBtnDateToggle}`)) {
        this.date = e.target.dataset.date;
        this.dateToggle();
      }
    });
  }

  monthToggle() {
    oc.ajax('onChangeMonth', {
      data: { month: this.month },
      update: { 'account/currency/calendar-ajax': `${this.calendarWrapper}` },
      success: function success(response) {
        this.success(response);
      },
    });
  }

  dateToggle() {
    oc.ajax('onChangeDate', {
      data: { date: this.date },
      update: { 'account/currency/rates-ajax': `${this.ratesWrapper}` },
      success: function success(response) {
        this.success(response);
      },
      loading: `${this.preLoaderSelector}`,
    });
  }
}();
